<div class="pill-container">
  <!-- Display-only mode: no link, just visual pill -->
  <div *ngIf="!isInternalLink && !isFileLink && displayString" class="pill">
    <div class="pill-text" [title]="displayString">{{ displayString }}</div>
  </div>

  <!-- Internal routes → real anchor with routerLink -->
  <a
    *ngIf="isInternalLink"
    class="pill"
    [routerLink]="routerCommands"
    [target]="openInNewTab ? '_blank' : null"
    (click)="onLinkClick($event)"
  >
    <span
      #statusIconEl
      *ngIf="statusEntry"
      class="status-icon"
      [style.borderColor]="statusEntry.iconColor"
      [style.color]="statusEntry.iconColor"
      [attr.aria-label]="statusEntry.label"
    >
      <ng-container [ngSwitch]="statusEntry.icon">
        <span *ngSwitchCase="'dots'" class="status-dots"><span></span><span></span><span></span></span>
        <span *ngSwitchCase="'pause-bars'" class="status-bars"><span></span><span></span></span>
        <i *ngSwitchDefault class="dx-icon dx-icon-{{ statusEntry.icon }}" [style.color]="statusEntry.iconColor"></i>
      </ng-container>
      <dx-tooltip [target]="statusIconEl" showEvent="mouseenter" hideEvent="mouseleave" position="top">
        <div *dxTemplate="let d of 'content'">{{ statusEntry.label }}</div>
      </dx-tooltip>
    </span>

    <app-svg-icon
      *ngIf="linkType === 'document' || linkType === 'techDocument' || icon"
      icon="document"
      [size]="18"
      color="var(--color-primary)"
    ></app-svg-icon>

    <div class="pill-text" [title]="displayString">{{ displayString }}</div>

    <span #extModEl class="external-mod-warning" *ngIf="externallyModified">
      <app-svg-icon icon="alert" [size]="18" color="var(--warning-color)"></app-svg-icon>
      <dx-tooltip [target]="extModEl" showEvent="mouseenter" hideEvent="mouseleave" position="top">
        <div *dxTemplate="let d of 'content'" i18n="@@fileModifiedExternally">Document was edited outside the system in SharePoint. Please check in SharePoint.</div>
      </dx-tooltip>
    </span>

    <span *ngIf="quantity !== null && quantity !== undefined" class="quantity-badge">
      {{ quantity }}
    </span>

    <dx-button
      *ngIf="editable"
      class="pill-close-button"
      icon="close"
      [width]="18"
      [height]="18"
      (onClick)="onClose($event)"
    ></dx-button>
  </a>

  <!-- File/doc links with a real URL → open natively in a new tab -->
  <a
    *ngIf="isFileLink && fileUrl"
    class="pill"
    [href]="fileUrl"
    target="_blank"
    rel="noopener"
    (click)="$event.stopPropagation()"
  >
    <span
      #statusIconEl
      *ngIf="statusEntry"
      class="status-icon"
      [style.borderColor]="statusEntry.iconColor"
      [style.color]="statusEntry.iconColor"
      [attr.aria-label]="statusEntry.label"
    >
      <ng-container [ngSwitch]="statusEntry.icon">
        <span *ngSwitchCase="'dots'" class="status-dots"><span></span><span></span><span></span></span>
        <span *ngSwitchCase="'pause-bars'" class="status-bars"><span></span><span></span></span>
        <i *ngSwitchDefault class="dx-icon dx-icon-{{ statusEntry.icon }}" [style.color]="statusEntry.iconColor"></i>
      </ng-container>
      <dx-tooltip [target]="statusIconEl" showEvent="mouseenter" hideEvent="mouseleave" position="top">
        <div *dxTemplate="let d of 'content'">{{ statusEntry.label }}</div>
      </dx-tooltip>
    </span>

    <app-svg-icon
      *ngIf="linkType === 'document' || linkType === 'techDocument' || icon"
      icon="document"
      [size]="18"
      color="var(--color-primary)"
    ></app-svg-icon>

    <div class="pill-text" [title]="displayString">{{ displayString }}</div>

    <span #extModEl class="external-mod-warning" *ngIf="externallyModified">
      <app-svg-icon icon="alert" [size]="18" color="var(--warning-color)"></app-svg-icon>
      <dx-tooltip [target]="extModEl" showEvent="mouseenter" hideEvent="mouseleave" position="top">
        <div *dxTemplate="let d of 'content'" i18n="@@fileModifiedExternally">Document was edited outside the system in SharePoint. Please check in SharePoint.</div>
      </dx-tooltip>
    </span>

    <span *ngIf="quantity !== null && quantity !== undefined" class="quantity-badge">
      {{ quantity }}
    </span>

    <dx-button
      *ngIf="editable"
      class="pill-close-button"
      icon="close"
      [width]="18"
      [height]="18"
      (onClick)="onClose($event)"
    ></dx-button>
  </a>

  <!-- File/doc links without a real URL → delegate to FileViewerService -->
  <button
    *ngIf="isFileLink && !fileUrl"
    type="button"
    class="pill"
    (click)="openFile($event)"
  >
    <span
      #statusIconEl
      *ngIf="statusEntry"
      class="status-icon"
      [style.borderColor]="statusEntry.iconColor"
      [style.color]="statusEntry.iconColor"
      [attr.aria-label]="statusEntry.label"
    >
      <ng-container [ngSwitch]="statusEntry.icon">
        <span *ngSwitchCase="'dots'" class="status-dots"><span></span><span></span><span></span></span>
        <span *ngSwitchCase="'pause-bars'" class="status-bars"><span></span><span></span></span>
        <i *ngSwitchDefault class="dx-icon dx-icon-{{ statusEntry.icon }}" [style.color]="statusEntry.iconColor"></i>
      </ng-container>
      <dx-tooltip [target]="statusIconEl" showEvent="mouseenter" hideEvent="mouseleave" position="top">
        <div *dxTemplate="let d of 'content'">{{ statusEntry.label }}</div>
      </dx-tooltip>
    </span>

    <app-svg-icon
      *ngIf="linkType === 'document' || linkType === 'techDocument' || icon"
      icon="document"
      [size]="18"
      color="var(--color-primary)"
    ></app-svg-icon>

    <div class="pill-text" [title]="displayString">{{ displayString }}</div>

    <span #extModEl class="external-mod-warning" *ngIf="externallyModified">
      <app-svg-icon icon="alert" [size]="18" color="var(--warning-color)"></app-svg-icon>
      <dx-tooltip [target]="extModEl" showEvent="mouseenter" hideEvent="mouseleave" position="top">
        <div *dxTemplate="let d of 'content'" i18n="@@fileModifiedExternally">Document was edited outside the system in SharePoint. Please check in SharePoint.</div>
      </dx-tooltip>
    </span>

    <span *ngIf="quantity !== null && quantity !== undefined" class="quantity-badge">
      {{ quantity }}
    </span>

    <dx-button
      *ngIf="editable"
      class="pill-close-button"
      icon="close"
      [width]="18"
      [height]="18"
      (onClick)="onClose($event)"
    ></dx-button>
  </button>
</div>
